import { DefaultState } from 'store/reducers/types';

export const READ_WORKER_REPORT_DATA_REQUEST = 'READ_WORKER_REPORT_DATA_REQUEST';
export const READ_WORKER_REPORT_DATA_SUCCESS = 'READ_WORKER_REPORT_DATA_SUCCESS';
export const READ_WORKER_REPORT_DATA_FAILURE = 'READ_WORKER_REPORT_DATA_FAILURE';

export interface WorkerReportRow {

};

export type WorkerReportData = {
  rows: WorkerReportData[] | [],
  totalCount: number;
};

export type WorkerReportState = DefaultState & {
  contents?: WorkerReportData;
};

interface ReadWorkerReportDataRequest {
  type: typeof READ_WORKER_REPORT_DATA_REQUEST;
};

interface ReadWorkerReportDataSuccess {
  type: typeof READ_WORKER_REPORT_DATA_SUCCESS,
  contents: WorkerReportData;
}

interface ReadWorkerReportDataFailure {
  type: typeof READ_WORKER_REPORT_DATA_FAILURE;
}

export type WorkerReportActionTypes = ReadWorkerReportDataRequest | ReadWorkerReportDataSuccess | ReadWorkerReportDataFailure;